module.exports = __webpack_public_path__ + "static/img/NE.a39ae346.png";